require('angular').module('wowApp.common')
    .service('AnonymousUserIdService', ['Restangular', require('./anonymous-userid-service')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/anonymoususerid/index.js
 **/